/* eslint-disable default-case */
import React, { useContext, useEffect, useState } from 'react';
import {
    Button,
    TextField,
    CssBaseline,
    Container,
    InputLabel,
    Select,
    FormControl,
    MenuItem,
    Grid
} from '@material-ui/core';
import PaisContext from 'context/pais/paisContext';
import ProvinciaContext from 'context/provincia/provinciaContext';
import LocalidadContext from 'context/localidad/localidadContext';
import ValidationsContext from "context/validations/validationsContext";
import ClienteContext from 'context/cliente/clienteContext';
import AuthContext from 'context/autentication/authContext';
import { makeStyles } from '@material-ui/core/styles';
import InputMask from "react-input-mask";
import {MdDelete, MdCheck} from "react-icons/md";
import BotonLoading from "components/Buttons/BotonLoading"

const useStyles = makeStyles(theme => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

const styless = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    dialogShare: {
      backgroudColor: "red",
      minWidth: '20%!important',
      minHeight: "60vh"
    }
  });

export default function Formulario({ cliente,grabarCliente, errorCliente, handleClose, alerta }) {
    const classes = useStyles();
    const paisContext = useContext(PaisContext);
    const { paises, obtenerPaises } = paisContext;

    const provinciaContext = useContext(ProvinciaContext);
    const { provincias, obtenerProvincias, obtenerProvincia } = provinciaContext;

    const localidadContext = useContext(LocalidadContext);
    const { localidades, obtenerLocalidades, obtenerLocalidad } = localidadContext;

    const authContext = useContext(AuthContext);
    const { autenticado, cliente:miCliente, usuario } = authContext;
    
    const clienteContext = useContext(ClienteContext);
    const {clientes,obtenerClientes} = clienteContext;
    const validationsContext = useContext(ValidationsContext);
    const { validateForm, validateUsername, validateeMail, validateDirecciones, validateCuit,
        validatePassword, validateCodigoArea, validateNumeroTelefono, validateRepeatPassword,
        validateDispositivoNombre } = validationsContext;
    const [open, setOpen] = useState(false)
    const cerrar = () => {
        setOpen(false)
    }
    const [state, setState] = useState({
        id:cliente.id,
        cuit: cliente.cuit,
        razonSocial: cliente.razonSocial,
        direccion: cliente.direccion,
        paisSelect: cliente.localidade.provincia.paise,
        provinciaSelect: cliente.localidade.provincia,
        localidad:cliente.localidade,
        telefonosCliente: cliente.telefonos
    });    
    const [telErrors, setTelErrors] = useState({
        codigoArea: "",
        telefono: "",
        index: -1
    })    
    const [jsonAux, setJsonAux]=useState({})
    const [miJsonConTelefonos, setTelefono]=useState(cliente.telefonos)
    /* cliente.telefono.map((x,index) => {
        miJsonConTelefonos[`${index}`] = x
    }) */
    const [posicion, setPosicion]=useState( )
    const pos=(x)=>{
        setPosicion(x)
    }
    const [tempTel, setTempTel] = useState({ codigoPais: "+54", numeroTelefono: "",numeroTelefonoFijo: "", codigoArea: "" })
    const [telElegido, setTelElegido]=useState("")
    const isFormIncomplete = () => {
        return (
            state.cuit.trim() === '' ||
            state.razonSocial.trim() === '' ||
            state.paisSelect === '' ||
            state.provinciaSelect === '' ||
            state.localidad === '' ||
            state.direccion.trim() === ''
        )
    }
    const isFormIncompleteTemp = () => {
        return (
            tempTel.codigoPais.trim() === "" ||
            tempTel.numeroTelefono.trim() ==="" ||
            tempTel.codigoArea.trim() === ""
        )
    }
    const [errors, setErrors] = useState({
        cuit: "",
        razonSocial: "",
        paisSelect: '',
        provinciaSelect: '',
        localidad: "",
        direccion: "",
    })

    const onChangeTel=(e, index) => {
        pos(index)
        let nT="numeroTelefono"
        let name= e.name
        if (index>-1){  
            if (name==="numeroTelefonoFijo"){
                setTelefono(miJsonConTelefonos=>(miJsonConTelefonos[index]["numeroTelefono"]=e.value, miJsonConTelefonos))
            } else {
                setTelefono(miJsonConTelefonos=>(miJsonConTelefonos[index][name]=e.value, miJsonConTelefonos))
            }
            pos()
            switch (name) {
                case 'codigoArea':
                    setTelErrors({
                        ...telErrors, codigoArea: validateCodigoArea(e.value.slice(2, 6).split("_")[0],miJsonConTelefonos[index]["numeroTelefono"].slice(2, 10).split("_")[0]),
                        telefono: validateNumeroTelefono(e.value.slice(2, 6).split("_")[0], miJsonConTelefonos[index]["numeroTelefono"].slice(2, 10).split("_")[0]),
                        index: index
                    });
                    break;
                case 'numeroTelefono':
                    setTelErrors({
                        ...telErrors, codigoArea: validateCodigoArea(miJsonConTelefonos[index]["codigoArea"].slice(2, 6).split("_")[0], e.value.slice(2, 10).split("_")[0]),
                        telefono: validateNumeroTelefono(miJsonConTelefonos[index]["codigoArea"].slice(2, 6).split("_")[0], e.value.slice(2, 10).split("_")[0]),
                        index: index
                    }); 
                    break;
                case 'numeroTelefonoFijo':
                    setTelErrors({
                        ...telErrors, codigoArea: validateCodigoArea(miJsonConTelefonos[index]["codigoArea"].slice(2, 6).split("_")[0], e.value.split("_")[0]),
                        telefono: validateNumeroTelefono(miJsonConTelefonos[index]["codigoArea"].slice(2, 6).split("_")[0], e.value.split("_")[0]),
                        index: index
                    });
                    break;
            } 
        } else {
            if (e.name==="numeroTelefonoFijo"){
                setTempTel({
                    ...tempTel,
                    [nT]: e.value,
                    [e.name]: e.value
                    });
            } else {
                setTempTel({
                    ...tempTel,
                    [e.name]: e.value});
            } 
            switch (e.name) {
                case 'codigoArea':
                    setTelErrors({
                        ...telErrors, codigoArea: validateCodigoArea(e.value.slice(2, 6).split("_")[0], tempTel.numeroTelefono.slice(2, 10).split("_")[0]),
                        telefono: validateNumeroTelefono(e.value.slice(2, 6).split("_")[0], tempTel.numeroTelefono.slice(2, 10).split("_")[0])
                    });
                    break;
                case 'numeroTelefono':
                    setTelErrors({
                        ...telErrors, codigoArea: validateCodigoArea(tempTel.codigoArea.slice(2, 6).split("_")[0], e.value.slice(2, 10).split("_")[0]),
                        telefono: validateNumeroTelefono(tempTel.codigoArea.slice(2, 6).split("_")[0], e.value.slice(2, 10).split("_")[0])
                    });
                    break;
                case 'numeroTelefonoFijo':
                    setTelErrors({
                        ...telErrors, codigoArea: validateCodigoArea(tempTel.codigoArea.slice(2, 6).split("_")[0], e.value.split("_")[0]),
                        telefono: validateNumeroTelefono(tempTel.codigoArea.slice(2, 6).split("_")[0], e.value.split("_")[0])
                    });
                    break;
            }
        }
        
    }
    ///// manejo de select de pais - provincia - localidad ///////

    const [paisSelectForm, setPaisSelectForm] = useState(cliente.localidade.provincia.paise.nombre)
    const [paisHash, setPaisHash] = useState({})
    const [paisArray, setPaisArray] = useState([])
    const [provSelectForm, setProvSelectForm] = useState(cliente.localidade.provincia.nombre)
    const [provHash, setProvHash] = useState({})
    const [provArray, setProvArray] = useState([])

    const [locSelectForm, setLocSelectForm] = useState(cliente.localidade.nombre)
    const [locHash, setLocHash] = useState({})
    const [locArray, setLocArray] = useState([])
    const [cuit, setCuit]=useState("")
    const crearSelectInfo = (array, tipo) => {
        let auxHash = {}
        let lista = []
        array.map( g => {
            auxHash[g.nombre] = g
            lista.push(g.nombre)
        })
        if (tipo === "pais") {
            setPaisHash(auxHash)
            setPaisArray(lista)
        }else if (tipo === "prov") {
            setProvHash(auxHash)
            setProvArray(lista)
        }else if (tipo === "loc") {
            setLocHash(auxHash)
            setLocArray(lista)
        } 

    }
    
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    useEffect(() => {
        if (paises) {
            crearSelectInfo(paises, "pais")
        }
        if (provincias) {
            crearSelectInfo(provincias, "prov")
        }
        if (localidades) {
            crearSelectInfo(localidades, "loc")
        }
    }, [localidades,provincias,paises]);
    
     useEffect(() => {
        if (paises.length === 0) {
            obtenerPaises()
                .then(value => obtenerProvincias(state.paisSelect.id)
                    .then(value => obtenerLocalidades(state.provinciaSelect.id)
                    )
                );
        }
        setErrors({
            cuit: "",
            razonSocial: "",
            paisSelect: '',
            provinciaSelect: '',
            localidad: "",
            direccion: "",
        }) 
        // eslint-disable-next-line
    }, []); 
    const  [clienteOr, setCliente]= useState();
    const clienteOriginal =(x)=>{
        setCliente(x.filter(c=>c.id === state.id))
    }
    useEffect(() => {
        obtenerClientes(miCliente).then(value=>clienteOriginal(value))
    }, []);
    const onChangePais = (e) => {
        setState({
            ...state,
            paisSelect: paisHash[e.value],
            localidad: "",
        });
        setPaisSelectForm(e.value)
        setProvSelectForm("")
        setLocSelectForm("")
        obtenerProvincias(e.value);
    }
    const onChangeProvincia = (e) => {
        setState({
            ...state,
            provinciaSelect: provHash[e.value],
            localidad: "",
        });
        setProvSelectForm(e.value)
        setLocSelectForm("")
        obtenerLocalidades(e.value);
    }
    const onChangeLocalidad = (e) => {
        setState({
            ...state,
            localidad: locHash[e.value],
        });
        setLocSelectForm(e.value)
    }
    
    const elegirTipoTel =(opcion)=>{
        if (opcion ==="celular"){
            tempTel.numeroTelefonoFijo=" "
            return tempTel.codigoPais="+549"
        } else if (opcion ==="telefono") {
            tempTel.numeroTelefono=""
            return tempTel.codigoPais="+54"
        }
        else {
            tempTel.numeroTelefono=""
            tempTel.numeroTelefonoFijo=" "
        }
    }
    const validarCuit = (cuit) => {
        let validado = cuit.split(" - ")
        let completo = validado[0]+validado[1]+validado[2]
        return completo
    }
    const cambiarTipoTel =(opcion, index)=>{
        if (opcion ==="celular"){
            miJsonConTelefonos[index]["numeroTelefono"]=""
            return miJsonConTelefonos[index]["codigoPais"]="+549"
        } else if (opcion ==="telefono") {
            miJsonConTelefonos[index]["numeroTelefono"]=""
            return miJsonConTelefonos[index]["codigoPais"]="+54"
        }
        else {
            miJsonConTelefonos[index]["numeroTelefono"]=""
        }
    }
    const onChange = (e) => {
        // cargo el preview
        setState({
            ...state,
            [e.name]: e.value
        });
        switch (e.name) {
            case 'razonSocial':
                setErrors({
                    ...errors, razonSocial: validateDispositivoNombre(e.value)
                });
                break;
            case 'direccion':
                setErrors({
                    ...errors, direccion: validateDirecciones(e.value)
                });
                break;
            case 'cuit':
                setErrors({
                    ...errors, cuit: validateCuit(validarCuit(e.value))
                });
                break;
            default:
                break;
        }
    }
    const cuitFormato =()=>{ 
        const n1=state.cuit.slice(0,2);
        const n2=state.cuit.slice(5,13);
        const n3=state.cuit.slice(16,17);
        const n4= n1+n2+n3
        return n4
    }
    const pushNewTel= ()=>{
        let index= Object.keys(miJsonConTelefonos).length
        setTelefono(miJsonConTelefonos => (miJsonConTelefonos[index]= tempTel, miJsonConTelefonos));
        const a=state.telefonosCliente
        a.push(tempTel)
        setState({...state, telefono:a })
        setTempTel({ codigoPais: "+54", numeroTelefono: "",numeroTelefonoFijo: "", codigoArea: "" })
    }
 
    // Cuando el usuario guardar o actualizar la localidad
    const onSubmit = () => {
        let array=[];
        for (let x in miJsonConTelefonos) {
            if (clienteOr[0].telefonos[x]) {
                if ((clienteOr[0].telefonos[x].codigoArea!==miJsonConTelefonos[x].codigoArea) || (clienteOr[0].telefonos[x].codigoPais!==miJsonConTelefonos[x].codigoPais) || (clienteOr[0].telefonos[x].numeroTelefono!==miJsonConTelefonos[x].numeroTelefono)){ 
                    array=[...array, {id:miJsonConTelefonos[x].id, codigoArea: miJsonConTelefonos[x].codigoArea.slice(1,5), codigoPais: miJsonConTelefonos[x].codigoPais , numeroTelefono: miJsonConTelefonos[x].numeroTelefono}]  
                } else {
                    array=[...array, {id:miJsonConTelefonos[x].id, codigoArea: miJsonConTelefonos[x].codigoArea, codigoPais: miJsonConTelefonos[x].codigoPais , numeroTelefono: miJsonConTelefonos[x].numeroTelefono}]  
                }
            } else {
                array=[...array, {id:miJsonConTelefonos[x].id, codigoArea: miJsonConTelefonos[x].codigoArea.slice(1,5), codigoPais: miJsonConTelefonos[x].codigoPais , numeroTelefono: miJsonConTelefonos[x].numeroTelefono}]  
            }
        } 
        // Validar que no haya campos vacios
        if (!validateForm(errors) || isFormIncomplete()) {
            errorCliente('Todos los campos con * son obligatorios', 'error');
        } else {
            state.localidad= state.localidad.id
            state.telefonosCliente= array.map((a)=>a) 
            if (state.cuit !== clienteOr[0].cuit){
                state.cuit = cuitFormato(state.cuit)
            } else { 
                state.cuit = clienteOr[0].cuit
            }
            // Pasarlo al action      
            grabarCliente(state)
            handleClose()
            // limpio el formulario
            setState({
                cuit: '',
                razonSocial: '',
                direccion: '',
                paisSelect: '',
                provinciaSelect: '',
                localidad: '',
                logo: '',
                telefono: '',
            });
        }
    }
    const abrir =()=>{
        setOpen(true)
    }
    const handleCloseT=()=>{
        setOpen(false)
    }
    const borrarTel=(index)=>{
        handleCloseT() 
        delete miJsonConTelefonos[index]
        let large = Object.keys(miJsonConTelefonos).length;
        delete miJsonConTelefonos[large]
        state.telefonosCliente.splice(index, 1);
        const a=state.telefonosCliente
        setState({...state, telefono:a })
    }
    return (
        <Container component="main"  >
            <CssBaseline />
            {state &&
            <div className={classes.form} noValidate onSubmit={(e)=>onSubmit(e)} autoComplete="off">
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4} lg={4} >
                    <InputMask
                            mask="99 \- 99999999 \- 9"
                            value={state.cuit}
                            onChange={(e)=>{onChange(e.target)}}
                        >
                        {() => (
                            <TextField variant="outlined"
                                error={errors.cuit.length > 0}
                                margin="normal"
                                required fullWidth id="cuit"
                                label={errors.cuit.length > 0 ? errors.cuit : "Cuit"}
                                name="cuit"
                                value={state.cuit}
                                autoComplete="cuit"
                            />
                        )}
                        </InputMask>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4} >
                        <TextField variant="outlined"
                            error={errors.razonSocial.length > 0}
                            margin="normal"
                            required fullWidth id="razonSocial"
                            label={errors.razonSocial.length > 0 ? errors.razonSocial : "Razón Social"}
                            name="razonSocial"
                            value={state.razonSocial}
                            onChange={(e)=>onChange(e.target)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4} lg={4} >
                        <TextField
                            required
                            error={errors.direccion.length > 0}
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            fullWidth id="direccion"
                            label={errors.direccion.length > 0 ? errors.direccion : "Dirección"}
                            name="direccion"
                            value={state.direccion}
                            onChange={(e)=>onChange(e.target)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4} lg={4} >
                        <FormControl variant="outlined" fullWidth margin="normal">
                            <InputLabel id="pais-label">Pais</InputLabel>
                            <Select
                                error={state.paisSelect.length === 0}
                                labelId="demo-simple-select-outlined-label"
                                id="pais"
                                name="pais"
                                value={paisSelectForm}
                                onChange={(e)=>onChangePais(e.target)}
                                label="Pais"
                            >
                                {paisArray.length === 0
                                    ? (<MenuItem value=''>No hay paises</MenuItem >)
                                    :
                                    paisArray.map(p => (
                                        <MenuItem key={p} value={p}>{p}</MenuItem >
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4} >
                        <FormControl variant="outlined" fullWidth margin="normal">
                            <InputLabel id="pais-label">Provincia</InputLabel>
                            <Select
                                error={state.provinciaSelect.length === 0}
                                labelId="demo-simple-select-outlined-label"
                                id="provincia"
                                name="provincia"
                                value={provSelectForm}
                                onChange={(e)=>onChangeProvincia(e.target)}
                                label="Provincia"
                            >
                                {provArray.length === 0
                                    ? (<MenuItem value=''>No hay provincia</MenuItem >)
                                    :
                                    provArray.map(prov => (
                                        <MenuItem value={prov}>{prov}</MenuItem >
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4} >
                        <FormControl variant="outlined" fullWidth margin="normal">
                            <InputLabel id="pais-label">Localidad</InputLabel>
                            <Select
                                error={state.localidad.length === 0}
                                labelId="demo-simple-select-outlined-label"
                                id="localidad"
                                name="localidad"
                                value={locSelectForm}
                                onChange={(e)=>onChangeLocalidad(e.target)}
                                label="Localidad"
                            >
                                {locArray.length === 0
                                    ? (<MenuItem value=''>No hay localidades</MenuItem >)
                                    :
                                    locArray.map(loc => (
                                        <MenuItem  value={loc}>{loc}</MenuItem >
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} >
                        <Grid item xs={12} md={12} lg={12}>
                            <p> Información de contacto</p>
                            <hr/>
                        </Grid>
                        {state.telefonosCliente && state.telefonosCliente.map((tel,index)=>
                        <Grid container direction="column" alignItems="flex-end"  justify="flex-end" spacing={1}>
                            <Grid item xs={12}>
                                <Grid container direction="row" spacing={2} justify="center" alignItems="center">
                                        <Grid item xs={6} md={4} lg={4}>
                                            <FormControl variant="outlined" fullWidth margin="normal" /* style={{margin:"0px", padding:"0px"}} */>
                                                <Select
                                                    variant="outlined"
                                                    required
                                                    fullWidth
                                                    labelId="tel"
                                                    id={index}
                                                    name="tel"
                                                    value={/* (miJsonConTelefonos[index]["codigoPais"]==="+549") ? */ "Celular"/*  : ((miJsonConTelefonos[index]["codigoPais"]==="+54") ? "Teléfono Fijo" : " ") */}
                                                    onChange={(e)=>onChange(e.target)}
                                                    label="Tipo"
                                                    >
                                                        <MenuItem  value="Celular" onClick={()=>cambiarTipoTel("celular", index)}>Celular</MenuItem>
                                                        <MenuItem  value="Teléfono Fijo" onClick={()=>cambiarTipoTel("telefono", index)} >Teléfono Fijo</MenuItem>
                                                </Select>  
                                            </FormControl>
                                        </Grid>
                                        {miJsonConTelefonos[index]["codigoPais"]==="+549" ? <>
                                                <Grid item xs={6} md={3} lg={3}>
                                                        <InputMask
                                                            maskChar=""
                                                            mask="\09999"
                                                            value={miJsonConTelefonos[index]["codigoArea"]}
                                                            onChange={(e)=>{onChangeTel(e.target ,index )}}
                                                        >
                                                            {() => (
                                                                <TextField
                                                                variant="outlined"
                                                                margin="normal"
                                                                required
                                                                fullWidth
                                                                name="codigoArea"
                                                                label={"Codigo Area"}
                                                                id="codigoArea"
                                                                margin="normal"
                                                                type="text"
                                                                />
                                                            )}
                                                        </InputMask>
                                                </Grid>
                                                <Grid item xs={10} md={4} lg={4} >
                                                    <InputMask
                                                        maskChar=""
                                                        mask="1\599999999"
                                                        value={miJsonConTelefonos[index]["numeroTelefono"]}
                                                        onChange={(e)=>{onChangeTel(e.target, index)}}
                                                    >
                                                        {() => (
                                                            <TextField
                                                            variant="outlined"
                                                            margin="normal"
                                                            required
                                                            fullWidth
                                                            name="numeroTelefono"
                                                            label={"Número"}
                                                            id="numeroTelefono"
                                                            margin="normal"
                                                            type="text"
                                                            />
                                                        )}
                                                    </InputMask>
                                                </Grid>
                                                
                                                    </>
                                            : 
                                            <>
                                                <Grid item xs={6} md={3} lg={3}>
                                                    <InputMask
                                                        maskChar=""
                                                        mask="\09999"
                                                        value={miJsonConTelefonos[index]["codigoArea"]}
                                                        onChange={(e)=>{onChangeTel(e.target, index)}}
                                                    >
                                                        {() => (
                                                            <TextField
                                                            variant="outlined"
                                                            margin="normal"
                                                            required
                                                            fullWidth
                                                            name="codigoArea"
                                                            label={"Codigo Area"}
                                                            id="codigoArea"
                                                            margin="normal"
                                                            type="text"
                                                            />
                                                        )}
                                                    </InputMask>
                                                </Grid>
                                                <Grid item xs={10} md={4} lg={4} >
                                                    <InputMask
                                                        maskChar=""
                                                        mask="99999999"
                                                        value={miJsonConTelefonos[index]["numeroTelefono"]}
                                                        onChange={(e)=>{onChangeTel(e.target, index)}}
                                                        >
                                                        {() => (
                                                        <TextField
                                                            variant="outlined"
                                                            margin="normal"
                                                            required
                                                            fullWidth
                                                            name="numeroTelefonoFijo"
                                                            label={"Número"}
                                                            id="numeroTelefonoFijo"
                                                            type="text"
                                                        />)}
                                                    </InputMask>
                                                </Grid>
                                            </>}
                                            <Grid item xs={2} md={1} lg={1}>
                                                <Button onClick={()=>borrarTel(index)}>
                                                    <MdDelete/>
                                                </Button>
                                            </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        )}
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                        <Grid container display="row" spacing={2} justify="center" alignItems="center">
                            <Grid item xs={6} md={4} lg={4}>
                                <FormControl variant="outlined" fullWidth margin="normal" /* style={{margin:"0px", padding:"0px"}} */>
                                    <Select
                                        variant="outlined"
                                        required
                                        fullWidth
                                        labelId="tel"
                                        name="tel"
                                        value={(tempTel.codigoPais==="+549") ? "Celular" : ((tempTel.codigoPais==="+54") ? "Teléfono Fijo" : " ")} 
                                        onChange={(e)=>onChange(e.target)}
                                        label="Tipo">
                                            <MenuItem  value="Celular" onClick={()=>elegirTipoTel("celular")}>Celular</MenuItem>
                                            <MenuItem  value="Teléfono Fijo" onClick={()=>elegirTipoTel("telefono")} >Teléfono Fijo</MenuItem>
                                    </Select>  
                                </FormControl>
                            </Grid>
                            {tempTel.codigoPais==="+549" ? <>
                                <Grid item xs={6} md={3} lg={3}>
                                                <InputMask
                                                    maskChar=""
                                                    mask="\09999"
                                                    value={tempTel.codigoArea}
                                                    onChange={(e)=>{onChangeTel(e.target)}}
                                                >
                                                    {() => (
                                                        <TextField
                                                        variant="outlined"
                                                        margin="normal"
                                                        required
                                                        fullWidth
                                                        name="codigoArea"
                                                        label={"Codigo Area"}
                                                        id="codigoArea"
                                                        margin="normal"
                                                        type="text"
                                                        onClick={()=>setTelErrors({...telErrors, index: -1})}
                                                    />
                                                    )}
                                                </InputMask>
                                        </Grid>                    
                                <Grid item xs={10} md={4} lg={4} >
                                    <InputMask
                                        maskChar=""
                                        mask="1\599999999"
                                        value={tempTel.numeroTelefono}
                                        onChange={(e)=>{onChangeTel(e.target)}} 
                                    >
                                        {() => (
                                            <TextField
                                            variant="outlined"
                                            margin="normal"
                                            required
                                            fullWidth
                                            name="numeroTelefono"
                                            label={"Número"}
                                            id="numeroTelefono"
                                            margin="normal"
                                            type="text"
                                            onClick={()=>setTelErrors({...telErrors, index: -1})}
                                        />
                                        )}
                                    </InputMask>
                                </Grid>
                            </>
                            :
                            <>
                            <Grid item xs={6} md={3} lg={3}>
                                <InputMask
                                    maskChar=""
                                    mask="\09999"
                                    value={tempTel.codigoArea}
                                    onChange={(e)=>{onChangeTel(e.target)}}
                                >
                                    {() => (
                                        <TextField
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        fullWidth
                                        name="codigoArea"
                                        label={"Codigo Área"}
                                        id="codigoArea"
                                        margin="normal"
                                        type="text"
                                        onClick={()=>setTelErrors({...telErrors, index: -1})}
                                        label={"Codigo Area"}
                                    />
                                    )}
                                </InputMask>
                            </Grid>
                            <Grid item xs={10} md={4} lg={4} >
                                <InputMask
                                    maskChar=""
                                    mask="99999999"
                                    value={tempTel.numeroTelefonoFijo}
                                    onChange={(e)=>{onChangeTel(e.target)}}
                                    >
                                    {() => (
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        fullWidth
                                        name="numeroTelefonoFijo"
                                        label={"Número"}
                                        id="numeroTelefonoFijo"
                                        margin="normal"
                                        type="text"
                                        onClick={()=>setTelErrors({...telErrors, index: -1})}
                                        label={ "Número"}
                                    />
                                    )}
                                </InputMask>
                        </Grid>
                        </>}
                        <Grid item xs={2} md={1} lg={1} >
                            {isFormIncompleteTemp() ?
                                <Button mx="auto"
                                    disabled
                                    color="primary"
                                    style={{padding:"0px", margin:"0px"}}
                                    >
                                    <MdCheck style={{marginLeft:"-25px"}}/>
                                </Button>
                                : 
                                <Button mx="auto" 
                                    color="primary"
                                    onClick={()=>pushNewTel()}
                                    style={{color:"#0B3845", padding:"0px", margin:"0px"}}
                                    >
                                    <MdCheck style={{marginLeft:"-25px"}}/>
                                </Button>
                            } 
                    </Grid>
                        </Grid>
                    </Grid>
                <Grid item xs={12}  >
                            {isFormIncomplete() || !validateForm(errors)  || (Object.keys(miJsonConTelefonos).length===0) ?
                                <>
                                {(Object.keys(miJsonConTelefonos).length===0) ? <p style={{color:"red", textAlign:"center"}}> * Debe ingresar al menos un teléfono de contacto</p> : null}
                                <Grid container justify="flex-end" >
                                    <Grid item xs={12} md={4} lg={4}  >
                                        <BotonLoading texto={"Guardar"} disabled={true} load={alerta} onClick={onSubmit}/>
                                    </Grid>
                                </Grid>
                                </>
                                :
                                <Grid container justify="flex-end" >
                                    <Grid item xs={12} md={4} lg={4}  >
                                        <BotonLoading texto={"Guardar"} disabled={false} load={alerta} onClick={onSubmit}/>
                                    </Grid>
                                </Grid>
                                }
                        
                </Grid>
            </Grid>
            </div>
        }           
        </Container>
    )
}

